export default "__VITE_ASSET__DNUX7d1b__"